import {
  SET_DESTINATION_NUMBER,
  ADD_DIGIT_TO_DESTINATION_NUMBER,
  DEV_PHONE_NUMBER_SELECTED,
  CONFIGURE_NUMBER_IN_USE,
  DEV_PHONE_CONFIG_ERROR,
} from './types';

export function setDestinationNumber(number) {
  return {
    type: SET_DESTINATION_NUMBER,
    number,
  };
}

export function addDigitToDestinationNumber(digit) {
  return {
    type: ADD_DIGIT_TO_DESTINATION_NUMBER,
    digit,
  };
}

export function selectDevPhoneNumberRequest() {
  return {
    type: DEV_PHONE_NUMBER_SELECTED,
  };
}

export function changeNumberInUse(number) {
  return {
    type: CONFIGURE_NUMBER_IN_USE,
    number,
  };
}

export function devPhoneConfigError(error) {
  return {
    type: DEV_PHONE_CONFIG_ERROR,
    error,
  };
}

export function configureNumberInUse(number) {
  return function (dispatch) {
    dispatch(selectDevPhoneNumberRequest());
    const numberObj = typeof number === 'string'
      ? { phoneNumber: number }
      : number;
    dispatch(changeNumberInUse(numberObj));
  };
}
